import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Image } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import './ProductComponent.css'

export default function ProductComponent(props) {
    console.log(props)
    const navigate = useNavigate()
    return (
        <div className='position-relative' style={{ cursor: 'pointer' }} onClick={() => navigate(`/product/${props.title}`, {
            state: {
                title: props.title,
                image: props.image,
            }
        })}>
            <Image src={props.image} className='product-image' />
            <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='product-title position-absolute d-flex justify-content-center align-items-center px-5'>
                <AnimationOnScroll duration={2} delay={50} animateIn="animate__slideInUp">
                    {props.title}
                </AnimationOnScroll>
            </AnimationOnScroll>
        </div>
    )
}
